import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    boxTitle: {
      borderRadius: 5,
      padding: '8px 16px',
    },
    boxLabel: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1,
      textTransform: 'uppercase',
    },
    statisticsBoxContainer: {
      alignItems: 'center',
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'column',
      height: 100,
      justifyContent: 'center',
    },
    count: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(56),
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: theme.typography.pxToRem(60),
      margin: 0,
    },
    label: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: theme.typography.pxToRem(15),
    },
    arrowIcon: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(24),
      marginRight: '-0.5rem',
    },
    infoIcon: {
      fontSize: theme.typography.pxToRem(15),
      marginLeft: 4,
    },
  };
});

export default useStyles;
